<template>
  <div class="logs-panel-loading" role="status" aria-live="polite" aria-busy="true" data-testid="logs-panel-loading">
    <span class="sr-only">Loading logs</span>
    <div v-for="n in 3" :key="n" class="logs-panel-loading__row">
      <div class="logs-panel-loading__badge" />
      <div class="logs-panel-loading__timestamp" />
      <div class="logs-panel-loading__message" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.logs-panel-loading {
  @apply flex flex-col;
}

.logs-panel-loading__row {
  @apply flex items-center gap-3 px-4 py-3 border-b border-zinc-100 dark:border-zinc-700/60;
}

.logs-panel-loading__badge {
  @apply h-4 w-12 rounded bg-zinc-200 dark:bg-zinc-700 animate-pulse;
}

.logs-panel-loading__timestamp {
  @apply h-3 w-10 rounded bg-zinc-200 dark:bg-zinc-700 animate-pulse;
}

.logs-panel-loading__message {
  @apply h-3 flex-1 rounded bg-zinc-200 dark:bg-zinc-700 animate-pulse;
}

.sr-only {
  @apply absolute w-px h-px p-0 -m-px overflow-hidden whitespace-nowrap border-0;
  clip: rect(0, 0, 0, 0);
}
</style>
